import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import DnsIcon from '@material-ui/icons/Dns';
import StorageIcon from '@material-ui/icons/Storage';

const serversRoute = createRouteRef();
const databasesRoute = createRouteRef();

export const serversPlugin = createFrontendPlugin({
  pluginId: 'servers',
  routes: { root: serversRoute },
  extensions: [
    PageBlueprint.make({
      params: {
        routeRef: serversRoute,
        path: '/servers',
        title: 'Servers',
        icon: <DnsIcon />,
        loader: () =>
          import('./ServersPage').then(module => <module.ServersPage />),
      },
    }),
  ],
});

export const databasesPlugin = createFrontendPlugin({
  pluginId: 'databases',
  routes: { root: databasesRoute },
  extensions: [
    PageBlueprint.make({
      params: {
        routeRef: databasesRoute,
        path: '/databases',
        title: 'Databases',
        icon: <StorageIcon />,
        loader: () =>
          import('./DatabasesPage').then(module => <module.DatabasesPage />),
      },
    }),
  ],
});
